import {
  AuditOutlined,
  GlobalOutlined,
  HomeOutlined,
  ProjectOutlined,
  SignatureOutlined,
  UserOutlined,
} from '@ant-design/icons';

export interface IRoute {
  path: string;
  title: string;
  description?: string;
  permission?: string;
  icon?: any;
  children?: IRoute[];
  isAdmin?: boolean;
}

export enum Route {
  PAGE500 = 'PAGE500',
  PAGE403 = 'PAGE403',

  LOGIN = 'LOGIN',

  HOME = 'HOME',
  THONG_TIN_CA_NHAN = 'THONG_TIN_CA_NHAN',
  CHAM_CONG = 'CHAM_CONG',

  NGHI_PHEP = 'NGHI_PHEP',
  NGHI_PHEP_DON_CUA_TOI = 'NGHI_PHEP_DON_CUA_TOI',
  NGHI_PHEP_PHE_DUYET = 'NGHI_PHEP_PHE_DUYET',

  CONG_VIEC = 'CONG_VIEC',
  BANG_KRA = 'BANG_KRA',
  BANG_KRA_CAP_DUOI = 'BANG_KRA_CAP_DUOI',
  BANG_KRA_CAP_DUOI_CHI_TIET = 'BANG_KRA_CAP_DUOI_CHI_TIET',
  BANG_KR_MUC_TIEU = 'BANG_KR_MUC_TIEU',
  BANG_KR_CAP_DUOI = 'BANG_KR_CAP_DUOI',
  BANG_KR_CAP_DUOI_CHI_TIET = 'BANG_KR_CAP_DUOI_CHI_TIET',
  BANG_KR_PHONG_BAN = 'BANG_KR_PHONG_BAN',

  TIN_TUC = 'TIN_TUC',
  TIN_TUC_THEM_MOI = 'TIN_TUC_THEM_MOI',
  TIN_TUC_CHINH_SUA = 'TIN_TUC_CHINH_SUA',
}

export const Routes: { [key in Route]: IRoute } = {
  PAGE500: {
    path: '/loi',
    title: 'Lỗi hệ thống',
  },
  PAGE403: {
    path: '/loi-quyen-truy-cap',
    title: 'Lỗi quyền truy cập',
  },

  LOGIN: {
    path: '/dang-nhap',
    title: 'Đăng nhập',
  },

  HOME: {
    path: '/',
    title: 'Trang chủ',
    icon: <HomeOutlined />,
  },

  THONG_TIN_CA_NHAN: {
    path: '/thong-tin-ca-nhan',
    title: 'Thông tin cá nhân',
    icon: <UserOutlined />,
  },

  CHAM_CONG: {
    path: '/cham-cong',
    title: 'Chấm công',
    icon: <SignatureOutlined />,
  },

  NGHI_PHEP: {
    path: '/nghi-phep',
    title: 'Nghỉ phép',
    icon: <AuditOutlined />,
  },
  NGHI_PHEP_DON_CUA_TOI: {
    path: '/nghi-phep-don-cua-toi',
    title: 'Đơn của tôi',
  },
  NGHI_PHEP_PHE_DUYET: {
    path: '/nghi-phep-phe-duyet',
    title: 'Phê duyệt',
  },

  CONG_VIEC: {
    path: '/cong-viec',
    title: 'Công việc',
    icon: <ProjectOutlined />,
  },
  BANG_KRA: {
    path: '/cong-viec/bang-kra',
    title: 'Bảng KRA',
  },
  BANG_KRA_CAP_DUOI: {
    path: '/cong-viec/bang-kra-cap-duoi',
    title: 'KRA cấp dưới',
  },
  BANG_KRA_CAP_DUOI_CHI_TIET: {
    path: '/cong-viec/bang-kra-cap-duoi/:idNhanVien',
    title: 'Chi tiết KRA cấp dưới',
  },
  BANG_KR_MUC_TIEU: {
    path: '/cong-viec/bang-kr-muc-tieu',
    title: 'Bảng KR mục tiêu',
  },
  BANG_KR_CAP_DUOI: {
    path: '/cong-viec/bang-kr-cap-duoi',
    title: 'KR cấp dưới',
  },
  BANG_KR_CAP_DUOI_CHI_TIET: {
    path: '/cong-viec/bang-kr-cap-duoi/:idNhanVien',
    title: 'Chi tiết KR cấp dưới',
  },
  BANG_KR_PHONG_BAN: {
    path: '/cong-viec/bang-kr-muc-tieu',
    title: 'KR phòng ban',
  },

  TIN_TUC: {
    path: '/tin-tuc',
    title: 'Tin tức',
    icon: <GlobalOutlined />,
  },
  TIN_TUC_THEM_MOI: {
    path: '/tin-tuc/them-moi',
    title: 'Thêm tin tức',
  },
  TIN_TUC_CHINH_SUA: {
    path: '/tin-tuc/chinh-sua/:id',
    title: 'Chỉnh sửa tin tức',
  },
};
